<template>
  <BorderBox class="track-alarm-table">
    <MTable
      :i18nPath="i18nPath"
      :tableData="alarmList"
      :tableColumn="tableColumn"
      :has-pagination="false"
      height="100%"
    />
  </BorderBox>
</template>

<script>
import MTable from '@/components/mTable/m-table.vue';
import BorderBox from '@/components/borderBox/index.vue';

export default {
  inject: ['getAlarmList'],
  components: {
    MTable,
    BorderBox
  },
  data() {
    return {
      i18nPath: 'query',
      tableColumn: [
        { label: '报警内容', prop: 'content' },
        { label: '报警时间', prop: 'beginTime' }
        // { label: '地点', prop: 'location' }
      ]
    };
  },
  computed: {
    alarmList() {
      return this.getAlarmList();
    }
  }
};
</script>

<style lang="scss">
.track-alarm-table {
  width: 100%;
  height: 45%;
  margin-top: 10px;

  .m-table {
    height: 100%;
  }

  .el-table {
    background: unset !important;

    .el-table__body-wrapper {
      overflow: auto;
    }

    th,
    tr {
      background: inherit !important;
    }
  }
}
</style>
